import React from 'react';
import {   Table, Icon, List, Popup } from 'semantic-ui-react';
import { Link } from "react-router-dom";


const CrucigramaPalabrasRow=({crucigramapalabras, onShowModalBorrar, onShowModalActivar, color,form, permisos, editar})=>{
    return (
    <Table.Row>
                        <Table.Cell>{crucigramapalabras.num}</Table.Cell>
                        <Table.Cell>{crucigramapalabras.clue}</Table.Cell>
                        <Table.Cell>{crucigramapalabras.descripcion}</Table.Cell>
                        <Table.Cell textAlign="center">{crucigramapalabras.estatus}</Table.Cell>
                        <Table.Cell textAlign="center">
                            <List horizontal>
                                <List.Item>
        
                                    <Popup
                                            trigger={<Icon onClick={()=>editar(crucigramapalabras.id)}  name='edit outline' link   size="large"  color="teal" ></Icon>}
                                            content='Editar'   
                                          />
        
                                    
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name='trash alternate outline' link 
                                            onClick={()=>onShowModalBorrar(crucigramapalabras.id)} 
                                            size="large" color="red"  />
                                        }
                                        content='Borrar'
                                      />
                                </List.Item>
                                <List.Item>
                                    <Popup
                                        trigger={
                                            <Icon name={crucigramapalabras.idEstatus==1?'x':'check'} link  size="large" 
                                                color={crucigramapalabras.idEstatus==1?"orange":"green"}  
                                                onClick={()=>onShowModalActivar(crucigramapalabras.id)} 
                                            />
                                        }
                                        content={crucigramapalabras.idEstatus==1?'Inactivar':'Activar'}
                                      />  
                                    
                                </List.Item>
                            </List>
                    </Table.Cell>
                      
        </Table.Row>
    
    )
}


export default CrucigramaPalabrasRow;